import { apiClient } from './client';

export interface LtiTokens {
  access_token: string;
  refresh_token: string;
}

export async function exchangeLtiCode(code: string): Promise<LtiTokens> {
  return apiClient.post<LtiTokens>('/lti/exchange', { code });
}

export interface LtiRegistration {
  id: string;
  academy_id: string;
  platform_name: string;
  issuer: string;
  client_id: string;
  auth_login_url: string;
  auth_token_url: string;
  key_set_url: string;
  deployment_id: string;
  public_key: string;
  created_at: string;
}

export interface CreateLtiRegistrationPayload {
  platform_name: string;
  issuer: string;
  client_id: string;
  auth_login_url: string;
  auth_token_url: string;
  key_set_url: string;
  deployment_id: string;
}

export interface CreateLtiRegistrationResponse {
  registration: LtiRegistration;
  tool_launch_url: string;
  oidc_initiation_url: string;
  jwks_url: string;
  openid_config_url: string;
}

export async function listLtiRegistrations(): Promise<LtiRegistration[]> {
  return apiClient.get<LtiRegistration[]>('/academy/lti/registrations');
}

export async function createLtiRegistration(
  data: CreateLtiRegistrationPayload,
): Promise<CreateLtiRegistrationResponse> {
  return apiClient.post<CreateLtiRegistrationResponse>(
    '/academy/lti/registrations',
    data,
  );
}

export async function deleteLtiRegistration(id: string): Promise<void> {
  return apiClient.delete<void>(`/academy/lti/registrations/${id}`);
}

export interface SyncRosterResponse {
  synced: number;
  total: number;
}

export async function syncLtiRoster(registrationId: string): Promise<SyncRosterResponse> {
  return apiClient.post<SyncRosterResponse>(
    `/academy/lti/registrations/${registrationId}/sync-roster`,
    {},
  );
}
